<template>
	<div v-if="alertCondition" class="alert-container">
		<svgicon name="info" class="info"></svgicon>
		<div class="alert-message">
			<slot></slot>
		</div>
	</div>
</template>
<script>
import '../icons/info';
export default {
	props: {
		alertCondition: {
			type: Boolean,
			required: true
		}
	}
};
</script>
<style lang="scss" scoped>
.alert-container {
	display: flex;
	align-items: center;
	padding: 8px 5%;
	width: 100%;
	border-top: 1px solid $alert-container-border-color;
	border-bottom: 1px solid $alert-container-border-color;
	background-color: $alert-container-bgcolor;

	.info {
		display: inline-block;
		vertical-align: middle;
		width: 24px;
		height: 24px;
		flex-shrink: 0;
		margin-right: 8px;
		fill: $font-red-alert;
	}

	.alert-message {
		display: inline-block;
		vertical-align: middle;
		color: $font-red-alert;
		font-family: 'RobotoMedium';
		font-size: 14px;
		letter-spacing: 0.5px;
		text-align: left;

		@media (min-width: $breakpoint-mid) {
			font-size: 16px;
		}
	}
}
</style>
